import { NgModule } from '@angular/core';
import { NoauthGuard } from './guard/noauth.guard';
import { RouterModule, Routes } from '@angular/router';
import { UserAuthGuard } from '../user/guard/user-auth.guard';
import { AdminAuthGuard } from '../admin/guard/admin-auth.guard';
import { CoreCartComponent } from './components/core-cart/core-cart.component';
import { CoreSupportComponent } from './components/core-support/core-support.component';
import { CoreContactComponent } from './components/core-contact/core-contact.component';
import { CoreWelcomeComponent } from './components/core-welcome/core-welcome.component';
import { CoreFallbackComponent } from './components/core-fallback/core-fallback.component';
import { AccessDeniedComponent } from '@shared/components/access-denied/access-denied.component';
import { PageNotFoundComponent } from '@app/modules/shared/components/page-not-found/page-not-found.component';
import { CorePrivacyPoliciesComponent } from './components/core-privacy-policies/core-privacy-policies.component';
import { CoreFaqsLandingPageComponent } from './components/core-faqs-landing-page/core-faqs-landing-page.component';
import { CoreApiDocumentationComponent } from './components/core-api-documentation/core-api-documentation.component';
// import { FeatureComingSoonComponent } from '@shared/components/feature-coming-soon/feature-coming-soon.component';
import { CorePopUpLandingPageComponent } from './components/core-pop-up-landing-page/core-pop-up-landing-page.component';
import { CoreTermsAndConditionsComponent } from './components/core-terms-and-conditions/core-terms-and-conditions.component';
import { CoreProductsWrapperComponent } from './components/core-products/core-products-wrapper/core-products-wrapper.component';
import { PublicInformationPageComponent } from '../shared/components/public-information-page/public-information-page.component';
import { CoreReferralLandingPageComponent } from './components/core-referral-landing-page/core-referral-landing-page.component';
import { CorePromotionalDiscountsComponent } from './components/core-promotional-discounts/core-promotional-discounts.component';
import { CoreRedemptionLandingPageComponent } from './components/core-redemption-landing-page/core-redemption-landing-page.component';
import { CoreSubcriptionPricingPageComponent } from './components/core-subcription-pricing-page/core-subcription-pricing-page.component';
import { UserCheckoutSuccessfulComponent } from '../user/components/user-checkout/user-checkout-successful/user-checkout-successful.component';
import { CoreProductUseCasesComponent } from './components/core-products/core-products-wrapper/core-product-use-cases-wrapper/core-product-use-cases/core-product-use-cases.component';

const routes: Routes = [
  { path: '', component: CoreWelcomeComponent, canActivate: [NoauthGuard] },
  // { path: '**', component: FeatureComingSoonComponent },
  { path: 'support', component: CoreSupportComponent },
  { path: 'contact-us', component: CoreContactComponent },
  { path: 'faq', component: CoreFaqsLandingPageComponent },
  { path: 'terms', component: CoreTermsAndConditionsComponent },
  { path: 'pop-up-form', component: CorePopUpLandingPageComponent },
  { path: 'referral', component: CoreReferralLandingPageComponent },
  { path: 'privacy-policy', component: CorePrivacyPoliciesComponent },
  { path: 'pricing', component: CoreSubcriptionPricingPageComponent },
  { path: 'redemption', component: CoreRedemptionLandingPageComponent },
  { path: 'api-documentation', component: CoreApiDocumentationComponent },
  { path: 'cart', component: CoreCartComponent },
  { path: 'cart/payment/success', data: { page_title: 'Payments | Successful' }, component: UserCheckoutSuccessfulComponent },
  { path: 'products/:qr_category', component: CoreProductsWrapperComponent },

  {
    path: "products",
    children: [
      {
        path: ":qr_category",
        children: [
          {
            path: "",
            component: CoreProductsWrapperComponent
          },
          {
            path: "use-cases/:use_case",
            component: CoreProductUseCasesComponent
          },
        ],
      },
    ],
  },

  { path: 'blog', loadChildren: () => import('../blog/blog.module').then(m => m.BlogModule) },
  { path: 'qrs', loadChildren: () => import('../public/public.module').then(m => m.PublicModule) },
  { path: 'popups', loadChildren: () => import('../public/public.module').then(m => m.PublicModule) },
  { path: 'auth', loadChildren: () => import('./../auth/auth.module').then(m => m.AuthModule), canActivate: [NoauthGuard] },
  { path: 'user', loadChildren: () => import('./../user/user.module').then(m => m.UserModule), canActivate: [UserAuthGuard] },
  { path: 'admin', loadChildren: () => import('./../admin/admin.module').then(m => m.AdminModule), canActivate: [AdminAuthGuard] },
  {
    path: "fallbacks",
    component: CoreFallbackComponent
  },
  {
    path: "qr-is-scannable",
    component: PublicInformationPageComponent
  },
  {
    path: "promotion/discounts",
    component: CorePromotionalDiscountsComponent
  },
  {
    path: "newsletters/unsubscribed",
    component: PublicInformationPageComponent
  },
  {
    path: "403",
    component: AccessDeniedComponent
  },
  {
    path: "404",
    component: PageNotFoundComponent
  },
  { path: ':category', component: CoreWelcomeComponent, canActivate: [NoauthGuard] },
  {
    path: "**",
    redirectTo: '404'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoreRoutingModule { }
